import React from 'react';

export default function Portfolio() {
  return (
    <div className="appContainer">
      <section className="heroSection">
        <h1>Portfolio Website</h1>
        <p>A personal site to showcase projects</p>
    
      </section>

      <section className="projectsSection">
        <h2>Project Overview</h2>
        <p>
          A simple personal website to showcase skills and projects
        </p>

        <div style={{ margin: '40px 0', textAlign: 'center' }}>
  
        </div>

        <h2>Key Features</h2>
        <ul className="skillsList">
          <li>Built with React to create a clean UI</li>
        </ul>


        <h2 style={{ marginTop: '40px' }}>Tech Stack</h2>
        <ul className="skillsList">
          <li><strong>React</strong> — Frontend Application</li>
          <li><strong>CSS</strong> — Responsive UI Styling</li>
        </ul>


        <h2 style={{ marginTop: '40px' }}>Additional Info</h2>
        <p>
          This was a very short project made to simply have a shared area to showcase any projects I have worked on. It also serves as a way to practice React for simple apps.
        </p>

        <h2 style={{ marginTop: '40px' }}>What was learned</h2>
        <p>
          Basic React and making simple application for websites 
        </p>
      </section>

      <footer className="footerSection">
        Built by Cale Miller
      </footer>
    </div>
  );
}
